<template>
    <div class="row full-structure-block mt-4 clients">
		<div class="col-xl-6 col-xxl-6 col-lg-7 col-md-12 p-lr-0-sm">
			<div class="row multisteps-form categories">
				<div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 p-lr-0-sm">
					<div class="multisteps-form__form dis-flex flex-column">
						<div class="card pl-3 pr-3 pt-2 pb-2 dis-flex flex-row flex-m mb-2 multisteps-form__content">
							<div class="left_part">
								<div class="logo">
									<img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBtMte85WRrb6_CXMpTvaO1cxKC6-wdJMdeg&amp;s" alt="">
								</div>
							</div>
							<div class="buttons-whatch-attirute">
								<div class="btn small-form-btn bar-code fs-10 mt-0 pointer" title="Edit Client">
									<i class="uis uis-edit-alt fs-11"></i>
								</div>
							</div>
						</div>
						<div class="card pl-3 pr-3 pt-2 pb-2 dis-flex flex-row flex-m mb-2 multisteps-form__content">
							<div class="left_part">
								<div class="logo">
									<img src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Maxima_logo.svg/1200px-Maxima_logo.svg.png" alt="">
								</div>
							</div>
							<div class="buttons-whatch-attirute">
								<div class="btn small-form-btn bar-code fs-10 mt-0 pointer" title="Edit Client">
									<i class="uis uis-edit-alt fs-11"></i>
								</div>
							</div>
						</div>
						<div class="card pl-3 pr-3 pt-2 pb-2 dis-flex flex-row flex-m mb-2 multisteps-form__content">
							<div class="left_part">
								<div class="logo">
									<img src="https://upload.wikimedia.org/wikipedia/lv/5/50/Mego_logo.jpg" alt="">
								</div>
							</div>
							<div class="buttons-whatch-attirute">
								<div class="btn small-form-btn bar-code fs-10 mt-0 pointer" title="Edit Client">
									<i class="uis uis-edit-alt fs-11"></i>
								</div>
							</div>
						</div>
						<div class="card pl-3 pr-3 pt-2 pb-2 dis-flex flex-row flex-m mb-2 multisteps-form__content">
							<div class="left_part">
								<div class="logo">
									<img src="https://upload.wikimedia.org/wikipedia/commons/f/f1/IKI_logo.png" alt="">
								</div>
							</div>
							<div class="buttons-whatch-attirute">
								<div class="btn small-form-btn bar-code fs-10 mt-0 pointer" title="Edit Client">
									<i class="uis uis-edit-alt fs-11"></i>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
   
}

</script>

<style>
.clients {
	.left_part {
		display: flex;
		align-items: center;

		.logo {
			height: 32px;
			margin-right: .65rem;

			img {
				object-fit: contain;
				height: 100%;
			}
		}

		h6 {
			text-transform: uppercase;
			font-weight: 700;
		}
	}

	.buttons-whatch-attirute {
		margin-left: auto;
	}
}
</style>